import { Local } from '@core/models/local.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StepsData } from './data';
import { OwnerShipService } from '../../ownership.services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector   : 'app-progress-steps',
    templateUrl: './probress-steps.component.html',
    styleUrls  : ['./probress-steps.component.scss']
})
export class AppProgressStepsComponent implements OnInit, OnDestroy
{

    local: Local;
    items =  StepsData.Items;
    index: number;
    private _unsubscribeAll: Subject<any>;
    constructor(private route: ActivatedRoute, private _ownerShipService: OwnerShipService){
        this._unsubscribeAll = new Subject();
    }

    ngOnInit()
    {
        this._ownerShipService.localOnChanged.pipe(takeUntil(this._unsubscribeAll))
        .subscribe( local => {
            this.local = local;
           const status  = this.local.status;

           console.log(status);


           switch (status) {
               case 'COMPLETED':

                break;
                case 'ATTENDED':

                    this.items.filter(item =>  item.index === 2 ).map(( res, i ) => {
                        res.active = false;
                        res.completed = true;
                    });

                break;

                case 'VISIT-LOCAL':
                    this.items.filter(item =>  item.index === 2 ||  item.index === 3).map(( res, i ) => {
                        res.active = false;
                        res.completed = true;
                    });
                break;


                case 'SIGNATURE-CONTRACT':
                    this.items.filter(item =>  item.index === 2 || item.index === 3 || item.index === 4 ).map(( res, i ) => {
                        res.active = false;
                        res.completed = true;
                    });
                break;

           }


        });

    }



    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
